import { render, staticRenderFns } from "./EventCardViewer.vue?vue&type=template&id=bf6ad22e&scoped=true"
import script from "./EventCardViewer.vue?vue&type=script&lang=js"
export * from "./EventCardViewer.vue?vue&type=script&lang=js"
import style0 from "./EventCardViewer.vue?vue&type=style&index=0&id=bf6ad22e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf6ad22e",
  null
  
)

export default component.exports